import React, { useState, useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import {
  Icon,
  Grid,
  Menu,
  Form,
  Button,
  Segment,
  Header,
} from 'semantic-ui-react';
import { TextWidget } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import FabOverlayFieldsWidget from '../FabOverlayWidget/FabOverlayFieldsWidget';

const messages = defineMessages({
  fabItemHeader: {
    id: 'fab-item-header',
    defaultMessage: 'Campi del FAB',
  },
  addFabPath: {
    id: 'fab-add-rootpath',
    defaultMessage: 'Aggiungi radice di navigazione',
  },
  deleteButton: {
    id: 'fab-delete-button',
    defaultMessage: 'Elimina',
  },
  root_path: {
    id: 'fab-rootpath',
    defaultMessage: 'Radice di navigazione',
  },
  emptyActiveFabPath: {
    id: 'fab-emptyActiveFabPath',
    defaultMessage: 'Seleziona un path di navigazione',
  },
});

const FabOverlayWidget = ({
  value,
  id,
  onChange,
  required,
  title,
  description,
  openObjectBrowser,
}) => {
  const intl = useIntl();

  const defaultFabItem = (tabTitle) => ({
    tabTitle,
    title: '',
    description: {},
    image: '',
    linkUrl: null,
    labelUrl: null,
  });

  const defaultRootFab = (tabTitle) => ({
    rootPath: '/',
    fab: defaultFabItem(tabTitle),
  });

  const [fabConfiguration, setFabConfiguration] = useState([]);
  const [activeFab, setActiveFab] = useState(0);

  const handleChangeConfiguration = (value) => {
    setFabConfiguration(value);
    onChange(id, JSON.stringify(value));
  };

  const addFabPath = (e) => {
    e.preventDefault();
    const fabItemsNumber = fabConfiguration.length;
    const fabItem = `/tab${fabItemsNumber}`;
    let newfabConfiguration = [
      ...fabConfiguration,
      {
        ...defaultRootFab(`Tab ${fabItemsNumber}`),
        rootPath: fabItem,
      },
    ];

    handleChangeConfiguration(newfabConfiguration);
    setActiveFab(newfabConfiguration.length - 1);
  };

  const onChangeFab = (pathIndex, fabItem) => {
    let newMenuConfiguration = [...fabConfiguration];
    newMenuConfiguration[pathIndex]['fab'] = fabItem;

    handleChangeConfiguration(newMenuConfiguration);
  };

  const deleteMenuPath = (e, index) => {
    e.preventDefault();
    let newfabConfiguration = [...fabConfiguration];
    newfabConfiguration.splice(index, 1);

    if (activeFab === index) {
      setTimeout(() => setActiveFab(index > 0 ? index - 1 : 0), 0);
    }

    handleChangeConfiguration(newfabConfiguration);
  };

  const onChangeMenuPath = (index, menu) => {
    let newfabConfiguration = [...fabConfiguration];
    newfabConfiguration[index] = menu;

    handleChangeConfiguration(newfabConfiguration);
  };

  useEffect(() => {
    if (!fabConfiguration || fabConfiguration.length === 0) {
      if (value) {
        setFabConfiguration(JSON.parse(value));
      } else {
        const defaultConfig = [defaultRootFab('Tab 0')];
        setFabConfiguration(defaultConfig);
        onChange(id, JSON.stringify(defaultConfig));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fabConfiguration, id, onChange]);

  return (
    <div className="fab-configuration-widget">
      <Form.Field inline id={id}>
        <Grid>
          <Grid.Row>
            <Grid.Column width="12">
              <div className="path-configuration">
                <Menu pointing secondary className="fab-path-menu">
                  {fabConfiguration.map((menu, idx) => (
                    <Menu.Item
                      key={`fab-path-${idx}`}
                      name={menu.rootPath}
                      active={activeFab === idx}
                      onClick={() => {
                        setActiveFab(idx);
                      }}
                    >
                      <span>{flattenToAppURL(menu.rootPath)}</span>
                    </Menu.Item>
                  ))}
                  <Menu.Item
                    active={false}
                    name={intl.formatMessage(messages.addFabPath)}
                    onClick={addFabPath}
                  >
                    <Icon name="plus" />
                  </Menu.Item>
                </Menu>
                <Segment>
                  {activeFab > -1 && activeFab < fabConfiguration.length ? (
                    <Grid>
                      <Grid.Column width={12} className="fab-rootpath-segment">
                        <TextWidget
                          id="rootPath"
                          title={intl.formatMessage(messages.root_path)}
                          description=""
                          required={true}
                          value={flattenToAppURL(
                            fabConfiguration[activeFab].rootPath,
                          )}
                          onChange={(id, value) => {
                            onChangeMenuPath(activeFab, {
                              ...fabConfiguration[activeFab],
                              rootPath: value?.length ? value : '/',
                            });
                          }}
                        />
                        <div className="fab-rootpath-button-delete">
                          <Button
                            icon="trash"
                            negative
                            onClick={(e) => deleteMenuPath(e, activeFab)}
                            id="delete-fabpath"
                            content={intl.formatMessage(messages.deleteButton)}
                          />
                        </div>
                      </Grid.Column>
                      <Grid.Column width={12}>
                        <Header as="h3" className="fab-item-header">
                          {intl.formatMessage(messages.fabItemHeader)}
                        </Header>
                        {/* TO DO: fare la form */}

                        <FabOverlayFieldsWidget
                          id={id}
                          openObjectBrowser={openObjectBrowser}
                          fabItem={fabConfiguration[activeFab]?.fab}
                          onChange={(fab) => onChangeFab(activeFab, fab)}
                        />
                      </Grid.Column>
                    </Grid>
                  ) : (
                    <span>
                      {intl.formatMessage(messages.emptyActiveFabPath)}
                    </span>
                  )}
                </Segment>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form.Field>
    </div>
  );
};

export default FabOverlayWidget;
